import Storage from '@/utils/storage'

const getDefaultState = () => {
  return {
    title: 'Broker Hub',
    sidebar: {
      opened: Storage.getItem('sidebarStatus') ? !!+Storage.getItem('sidebarStatus') : true,
      withoutAnimation: false
    },
    riskFullScreen: false,
    device: 'desktop',
    size: Storage.getItem('size') || 'base',
    pageSize: +(Storage.getItem('pageSize') || 10),
    language: Storage.getItem('language') || 'en',
  }
}

const state = getDefaultState()

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Storage.setItem('sidebarStatus', 1)
    } else {
      Storage.setItem('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Storage.setItem('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  SETTING_RISK_FULLSCREEN: (state, val) => {
    state.riskFullScreen = val
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Storage.setItem('size', size)
  },
  SET_PAGESIZE: (state, pageSize) => {
    state.pageSize = pageSize
    Storage.setItem('pageSize', pageSize)
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Storage.setItem('language', language)
  },
  RESET_STORE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  toggleRiskFullScreen({ commit }, val) {
    commit('SETTING_RISK_FULLSCREEN', val)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setPageSize({ commit }, pageSize) {
    commit('SET_PAGESIZE', pageSize)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
